module.exports = __webpack_public_path__ + "img/pause-circle.dcd32887.svg";